import {styled} from "@mui/material/styles";
import Tooltip, {tooltipClasses, TooltipProps} from "@mui/material/Tooltip";
import {ReactElement} from "react";

import {PRIMARY} from "@/app/pages/upik/styles/palette";
import React from "react";

const BootstrapTooltip = styled(({
    className,
    ...props
}: TooltipProps) => (
    <Tooltip
        {...props}
        arrow={true}
        classes={{"popper": className}}
        disableHoverListener={true} />
))(() => ({
    [`& .${tooltipClasses.arrow}`]: {
        "color": PRIMARY.grayPrimary,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        "backgroundColor": PRIMARY.grayPrimary,
        "border-radius": "8px",
        "fontSize": "0.75em",
        "marginTop": "-5px",
        "maxWidth": "450px",
        "marginBottom": "-6px !important",
        "lineHeight": "1.75"
    },
}));

interface CustomizedTooltipsProps {
    children: ReactElement;
    content: ReactElement | string;
    openTooltip: boolean;
    toggleTooltip: (flag: boolean) => void;
}

export const CustomizedTooltips = ({
    children,
    content,
    openTooltip,
    toggleTooltip,
}: CustomizedTooltipsProps): JSX.Element => (
    <BootstrapTooltip
        onClose={() => {
            toggleTooltip(false);
        }}
        onOpen={() => {
            toggleTooltip(true);
        }}
        open={openTooltip}
        title={content}
    >
        {children}
    </BootstrapTooltip>
);
